const TIPOS_MODULOS = [
  // Generales
  {
    id: 4,
    name: 'Notificaciones de Terceros',
  },
  {
    id: 5,
    name: 'Control de Duplicados',
  },
  {
    id: 10,
    name: 'Exclusión de Organismos',
  },
  {
    id: 3,
    name: 'Envio de SMS',
  },
  {
    id: 27,
    name: 'Flujo de estados y avisos personalizado',
  },
  {
    id: 28,
    name: 'Flujo de aceptación de notificaciones',
  },
  {
    id: 23,
    name: 'Importaciones',
  },
  {
    id: 31,
    name: 'Columnas dinámicas',
  },
  {
    id: 32,
    name: 'Respuestas a notificaciones de la AEAT',
  },
  {
    id: 33,
    name: 'Organismos / Provincias',
  },
  {
    id: 34,
    name: 'Peticiones API',
  },
  {
    id: 35,
    name: 'Hotfolder de correos',
  },
  {
    id: 36,
    name: 'Informes personalizados',
  },
  {
    id: 37,
    name: 'Contestación de diligencias',
  },
  {
    id: 38,
    name: 'Asistencia por IA',
  },
  // Autenticación
  {
    id: 9,
    name: 'Integración AAD',
  },
  {
    id: 30,
    name: 'Integración SAML2',
  },
  {
    id: 29,
    name: 'Doble factor de autenticación',
  },
  // Descarga de archivos
  {
    id: 24,
    name: 'Personalización de fichero ZIP en correo',
  },
  {
    id: 21,
    name: 'Descargar solo Adjuntos Principales',
  },
  {
    id: 20,
    name: 'Descarga selectiva y renombrado',
  },
  // Agrupación y reparto
  {
    id: 11,
    name: 'Asignación por Metadatos de la AEAT',
  },
  {
    id: 12,
    name: 'Asignación por Sede, Organismo y CIF receptor',
  },
  {
    id: 13,
    name: 'Asignación por Contenido',
  },
  {
    id: 14,
    name: 'Asignación por Asunto',
  },
  {
    id: 25,
    name: 'Asignación de Destinatarios en reglas',
  },
  {
    id: 15,
    name: 'Agrupaciones',
  },
  {
    id: 6,
    name: 'Grupos de Reparto',
  },
  {
    id: 26,
    name: 'Permisos de Traspaso de NEOs entre Grupos',
  },
  // Vacaciones y horarios no disponibles
  {
    id: 1,
    name: 'Vacaciones Fiscales AEAT',
  },
  {
    id: 7,
    name: 'Calendarios de Festivos para Descarga',
  },
  {
    id: 8,
    name: 'Horarios de Descarga',
  },
  // Personalización
  {
    id: 18,
    name: 'Correos de avisos personalizados',
  },
  {
    id: 19,
    name: 'Logo personalizado',
  },
  {
    id: 22,
    name: 'Gama de Colores personalizada',
  },
  {
    id: 16,
    name: 'Correo SMTP proporcionada por Zerocoma',
  },
  {
    id: 17,
    name: 'Correo SMTP proporcionada por el cliente',
  },
]

export {
  TIPOS_MODULOS
}

